require('./gh_window.scss');

/**************************************************************************************************************/
/**********************************************    GH-WINDOWS     *********************************************/
/**************************************************************************************************************/

angular.module('ghWindowModule', [
    'ghConstructor'
])





/*=========================================================================================================*/
/*========================================  GH-WINDOWS DIRECTIVE   =========================================*/
/*=========================================================================================================*/
.directive('ghWindows', [ '$compile', 'ghWindowsService', function($compile, ghWindowsService) {
  return {
      restrict: 'E',
      scope: {},
      template: '<gh-window ng-if="!hideAllExceptLast || $last" window="windows[$index]" ng-repeat="window in windows" class="{{window.window_mode}}" window-model=\"window\" style=\"z-index:{{$index+1}};\"></gh-window>',

      controller: [ '$scope', '$injector', '$element', '$location', '$routeParams', function($scope,  $injector, $element, $location, $routeParams) {
          /*-- saving models list for all windows*/
          $scope.windows = [];
          var oldWindowId;

       
          /*--Binding GH-WINDOWS with Window service*/
          ghWindowsService.init($scope);

          $scope.$on('$locationChangeSuccess', function(){
            var current_url = $location.path();
            var patt = new RegExp(/^\/act(?:\/([^\/]+)?)?(?:\/([^\/]+)?)?(?:\/([^\/]+)?)?(?:\/([^\/]+)?)?$/);
            oldWindowId = $routeParams.actionType + '_' + ($routeParams.param_1 ? $routeParams.param_1 + '_': '') +  ($routeParams.param_3 ? $routeParams.param_3 + '_' : '') + ($routeParams.param_2 ? $routeParams.param_2 : '');

            if(patt.test(current_url)){
              if($element.css('display') != 'flex'){
                $element.css('display','flex');
              }
            } else {
              $element.css('display','none');
            }
          });

          window.addEventListener('popstate', () => {
            ghWindowsService.windowDestroy(oldWindowId, false);
          });

          $scope.hideAllExceptLast = false;

          $scope.changeVisibilityPreviousWindowsInDOM = function (isHide) {
            $scope.hideAllExceptLast = isHide;
          };

      }],

      link: function(scope, element, attrs) {

      }

  };
}])

/*-----------------------------  GH-WINDOW-NEW  -------------------------------*/
.directive('ghWindow', [ '$compile', 'ghWindowsService', 'GHConstructor', function($compile, ghWindowsService, GHConstructor) {
  return {
      restrict: 'E',
      scope: {
          window: '='
      },
      controller: [ '$scope', function($scope) {
          /* Close current window*/
          $scope.destroyWindow = function() {
              ghWindowsService.windowDestroy($scope.window.window_id);
          };
      }],
      link: function(scope, element, attrs) {


            GHConstructor.getInstance(scope.window.window_mode).then(function(response) {

                response.getWindowScope(scope);
                var el = angular.element( response.getWindowHTML(scope) );
                element.empty();
                element.append($compile(el)(scope));
            });
        }
  };
}])



/*=======================================================================================================*/
/*========================================  GH-WINDOWS SERVICE   =========================================*/
/*=======================================================================================================*/
.service('ghWindowsService', ['$injector', '$timeout', '$location', function($injector, $timeout, $location) {
  var windowsScope = {};

  var self= this;

  this.isWindowOpened = function (window_id){

    var isOpened = false;
    angular.forEach(windowsScope.windows, function(window, index){
      if(window.window_id == window_id){
        isOpened = true;
        /* -- Swap two elements of window in windows array -- */
        var windowsArr = windowsScope.windows;
        windowsArr[windowsArr.length - 1] = [windowsArr[index], windowsArr[index] = windowsArr[windowsArr.length - 1]][0];
      }
    });

    return isOpened;
  };

  /*------------- INITIALIZATION -------------*/
  this.init = function(scope) {
      windowsScope = scope;
  };

  /*--------------- NEW WINDOW --------------*/
  this.newWindow = function(actionType, scope) {
      var windowId = actionType + ( scope.app_id ? '_'+ scope.app_id : '' ) + ( scope.item_id ? '_'+ scope.item_id : '' ) + ( scope.view_id ? '_'+ scope.view_id : '' );

      /* Check if we want open window twice*/
      if(!self.isWindowOpened(windowId)){
        var windowScopeProp = {
            window_id: windowId, /*-- Window ID is equals windows url --*/
            window_mode: actionType,
            layer_position: windowsScope.windows.length,
            item_id: scope.item_id,
            app_id: scope.app_id,
            data: {},
        };

        angular.extend(windowScopeProp, scope);
        
        /*-- Creating new window in the GH-WINDOWS*/
        windowsScope.windows.push(windowScopeProp);
        $timeout(function() {
          windowsScope.$digest();//-- We added digest to fix showing popup window for Print document
        }, 0, false);

        if ($injector.get(actionType).getTemplate().hidePreviousWindows) {
          windowsScope.changeVisibilityPreviousWindowsInDOM(true);
        }
      }
  };

  this.windowDestroy = function(windowId, historyBack = true) {
    
    if (!windowId) {
      gudhub.util.selectedItems = {};
      windowsScope.windows = [];
      return;
    }

    let windowToDestroy = windowsScope.windows.find((w) => w.window_id == windowId);

    if (windowToDestroy) {
      let windowSettings = $injector.get(windowToDestroy.window_mode).getTemplate();
      windowsScope.windows.splice(windowsScope.windows.indexOf(windowToDestroy), 1);

      // There are several data types which opens in new window without route changing - so we don't need to do history back when window is closed
      if(windowSettings.run_on_rout && historyBack){
        //If you open gudhub item or app by direct link and close it, you will be redirected to /apps page instead of previous page
        windowsScope.windows.length == 0 ? $location.path('/apps') : window.history.go(-1);
      }

      if(windowSettings.hidePreviousWindows){
        windowsScope.changeVisibilityPreviousWindowsInDOM(false);
      }
    }
    // re run digest for add items and update items
    $timeout(function() {
        windowsScope.$digest();
    }, 0, false)
  };

}])

